// extracted by mini-css-extract-plugin
export var label = "_iw-0";
export var treatmentCard = "_iw-1";